import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const whatsNextContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.l,
  padding: vars.space.m,
});

export const whatsNextList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
});
